export default __webpack_public_path__ + "static/media/icon-contact-callback@2x.1c7f8485.svg";